<div #queryDesignerContainer class="abc-queries-editor-container">
  <abc-splitter
    #layoutSplitterComponent
    [orientation]="'horizontal'"
    [keepAspectRatio]="false"
    [minHeight]="uiSetting.RESULT_MINHEIGHT"
    [maxHeight]="uiSetting.RESULT_MAXHEIGHT"
    [height]="'100%'"
    (onResize)="dividerPanMove($event)"
  >
    <opath-core-layout [rtlEnabled]="rtlEnabled">
      <section
        class="abc-queries-editor-content"
        #content
        [style.display]="executeOnly ? 'none' : ''"
        [style.height]="'calc(100% - ' + uiSetting.RESULT_HEADER_HEIGHT + 'px)'"
        [style.flexDirection]="splitterHandle === 'left' ? 'row' : 'row-reverse'"
      >
        <!-- properties view change handle -->
        <div
          class="properties"
          [style]="rtlEnabled ? ' left: 0' : ' right : 0;'"
          [style.minWidth.px]="uiSetting.PROPERTIES_Min_WIDTH"
          [style.width]="
            currentSelectionView
              ? 'calc(100% - ' + (treeSplitterWidth + selectionSplitterWidth) + 'px)'
              : 'calc(100% - ' + treeSplitterWidth + 'px)'
          "
          id="propertiesContainer"
        >
          <abc-opath-queries-editor-general-properties
            *ngIf="currentPropertyView === PropertiesViews.GENERAL_PROPERTIES"
            (OnObjectSpaceNameChange)="refreshRoot()"
            (OnRootElementNameChange)="refreshRoot()"
            [emptyQueries]="emptyQueries"
          ></abc-opath-queries-editor-general-properties>
          <abc-opath-queries-editor-query-properties
            style="display: block; height: 100%"
            [refreshTree]="refreshTree"
            [deleteQueryContent]="deleteQueryContent"
            [refreshSelectColumns]="refreshSelectColumns"
            [selectedNode]="selectedNode"
            *ngIf="currentPropertyView === PropertiesViews.QUERY_PROPERTIES"
          ></abc-opath-queries-editor-query-properties>
          <abc-opath-queries-editor-column-properties
            [refreshTree]="refreshTree"
            [selectedNode]="selectedNode"
            *ngIf="currentPropertyView === PropertiesViews.COLUMN_PROPERTIES"
          ></abc-opath-queries-editor-column-properties>
        </div>

        <!-- selection view change handle -->
        <div
          class="selection"
          [style]="rtlEnabled ? ' right: ' + treeSplitterWidth + 'px' : ' left: ' + treeSplitterWidth + 'px'"
          [style.right.px]="treeSplitterWidth > 0 ? treeSplitterWidth : treeSplitter.minWidth"
          *ngIf="currentSelectionView"
          [style.minWidth.px]="selectionSplitter.minWidth"
          [style.width.px]="selectionSplitterWidth"
        >
          <abc-splitter
            [minWidth]="selectionSplitter.minWidth"
            [maxWidth]="selectionSplitter.maxWidth"
            [orientation]="splitterHandle"
            [(width)]="selectionSplitterWidth"
            [removeTransforms]="true"
            (onResizeEnd)="handleTreeSlplitersMaxWidth()"
            (onResizeStart)="handleSelectionSplitterMaxWidth()"
          >
            <abc-opath-queries-editor-select-columns
              style="display: block; height: 100%"
              [selectedNode]="selectedNode"
              [insertColumns]="selectColumnsInsertion"
              *ngIf="currentSelectionView === SelectionViews.SELECT_COLUMNS"
              [closeSelectionView]="closeSelectionView"
            ></abc-opath-queries-editor-select-columns>
            <abc-opath-queries-editor-select-object-type
              style="display: block; height: 100%"
              *ngIf="currentSelectionView === SelectionViews.SELECT_OBJECT_TYPE"
            ></abc-opath-queries-editor-select-object-type>
          </abc-splitter>
        </div>

        <!-- this is always visible -->
        <div
          class="queries-tree"
          [style.width.px]="treeSplitterWidth"
          [style]="rtlEnabled ? ' right: 0 ' : ' left: 0;'"
          [style.display]="executeOnly ? 'none' : ''"
        >
          <abc-splitter
            #treeSplitterRef
            [orientation]="splitterHandle"
            [removeTransforms]="true"
            (onResizeEnd)="handleSelectionSplitterMaxWidth()"
            (onResizeStart)="handleTreeSlplitersMaxWidth()"
            [minWidth]="treeSplitter.minWidth"
            [maxWidth]="treeSplitter.maxWidth"
            [(width)]="treeSplitterWidth"
          >
            <abc-opath-queries-editor-queries-tree
              style="display: block; height: 100%"
            ></abc-opath-queries-editor-queries-tree>
          </abc-splitter>
        </div>
      </section>
    </opath-core-layout>
  </abc-splitter>

  <!-- results component -->
  <div class="results-container" #resultsComponent>
    <span class="results-handle" (click)="toggleResults()" [style.display]="executeOnly ? 'none' : ''">
      <i *ngIf="resultsVisible; else closed" class="icon dx-icon-spindown"></i>
      <ng-template #closed><i class="icon dx-icon-spinup"></i></ng-template>
    </span>
    <section class="results-header" [style.display]="executeOnly ? 'none' : ''">
      <p>{{ translation?.resultsTitle }}</p>
    </section>
    <section #resultsBody class="results-body">
      <abc-opath-queries-editor-results
        *ngIf="resultsVisible"
        [currentResultsView]="currentResultsView"
        [autoExec]="realTimeQueryExec"
        [resultsEmpty]="resultsEmpty"
      ></abc-opath-queries-editor-results>
    </section>
  </div>
</div>
